import React, { Component } from 'react';
import { Space, Row, Col, Typography, message, Table, Popconfirm } from 'antd';
import { AppstoreOutlined, DownloadOutlined, SearchOutlined, SendOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import axios from 'axios';
import {
    ModalItem,
    InputItem,
    ButtonItem,
    dineroDisabledMask,
} from '../../../../Components/Items';
import debounce from "lodash.debounce";
import moment from 'moment';

const { Text } = Typography;

class ModalAgregarInsumosAExistente extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
            ordenes: [],
            totalOrdenes: 0,
            loading: false,
            currentPage: 1,
            pageSize: 10
        };

        // Aquí defines la función debounced
        this.debouncedConsultar = debounce(() => {
            this.consultarOrdenes();
        }, 500); // Puedes ajustar el delay en ms (ej. 500)
    }

    // Consultar ordenes cuando se abre el modal
    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.consultarOrdenes();
        }
    }


    // Consultar insumos desde la API
    consultarOrdenes = () => {
        this.setState({ loading: true });

        const { searchTerm, currentPage, pageSize } = this.state;

        axios
            .post(
                "requisiciones/selectOrdenesDeCompraPendientePaginado",
                {
                    empresaId: this.props.empresaId,
                    proveedorId: this.props.proveedorId,
                    query: searchTerm,
                    skip: (currentPage - 1) * pageSize,
                    limit: pageSize
                },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        ordenes: res.data.items.map((value) => {
                            return {
                                ...value,
                                proveedorNombre: value.proveedor.nombre ? value.proveedor.nombre + " " + value.proveedor.apellidoPaterno + " " + value.proveedor.apellidoMaterno
                                    : value.proveedor.razonSocial,
                                accion: {
                                    _id: value._id,
                                    estado: value.estado,
                                    xml: value.xml,
                                    estadoFactura: value.estadoFactura,
                                    requisicion: value.requisicion,
                                    finiquitada: value.finiquitada,
                                },
                            };
                        }),
                        totalOrdenes: res.data.total,
                        loading: false
                    });
                } else {
                    message.error("No se encontraron ordenes");
                    this.setState({ loading: false });
                }
            })
            .catch((error) => {
                console.error("Error al consultar ordenes:", error);
                message.error("Error al consultar ordenes");
                this.setState({ loading: false });
            });

    };

    onSearchChange = (e) => {
        this.setState({ searchTerm: e.target.value, currentPage: 1 }, () => {
            this.debouncedConsultar();
        });
    };

    onTableChange = (pagination) => {
        this.setState(
            {
                currentPage: pagination.current,
                pageSize: pagination.pageSize
            },
            () => {
                this.consultarVentas();
            }
        );
    };

    // Limpiar filtros al cerrar el modal
    handleCancel = () => {
        this.setState({
            searchTerm: '',
            ordenes: [],
            currentPage: 1
        });
        this.props.onCancel();
    };

    confirmarOrdenDeCompra(ordenId) {
        this.props.onConfirm(ordenId);
    }

    // Columnas de la tabla de productos
    getColumnsOrdenesDeCompra = () => [
        {
            title: "Num.",
            dataIndex: "numero",
            key: "numero",
            sorter: (a, b) => {
                if (a.numero < b.numero) {
                    return -1;
                }
                if (a.numero > b.numero) {
                    return 1;
                }
                return 0;
            },
            width: "6%",
            buscar: "numero",
            ellipsis: true,
        },
        // {
        //     title: "Req.",
        //     dataIndex: "requisicionNumero",
        //     key: "requisicionNumero",
        //     sorter: (a, b) => {
        //         if (a.requisicionNumero < b.requisicionNumero) {
        //             return -1;
        //         }
        //         if (a.requisicionNumero > b.requisicionNumero) {
        //             return 1;
        //         }
        //         return 0;
        //     },
        //     width: "6%",
        //     buscar: "requisicionNumero",
        //     align: "center",
        //     ellipsis: true,
        // },
        {
            title: "Proyecto",
            dataIndex: "proyecto",
            key: "proyecto",
            sorter: (a, b) => {
                if (a.proyecto.nombre < b.proyecto.nombre) {
                    return -1;
                }
                if (a.proyecto.nombre > b.proyecto.nombre) {
                    return 1;
                }
                return 0;
            },
            render: (value) => value.nombre,
            width: "10%",
            ellipsis: true,
        },
        {
            title: "Proveedor",
            dataIndex: "proveedorNombre",
            key: "proveedorNombre",
            sorter: (a, b) => {
                if (a.proveedorNombre < b.proveedorNombre) {
                    return -1;
                }
                if (a.proveedorNombre > b.proveedorNombre) {
                    return 1;
                }
                return 0;
            },
            buscar: 'proveedorNombre',
            render: (value, record) => {
                let buttons = [];

                if (record.enviada) {
                    buttons.push(<SendOutlined />)
                }

                if (record.descargada) {
                    buttons.push(<DownloadOutlined />)
                }

                return <Space size="small">{buttons}{value}</Space>

            },
            width: "13%",
            ellipsis: true,
        },
        {
            title: "Fecha",
            dataIndex: "createdAt",
            key: "createdAt",
            sorter: (a, b) => {
                if (moment(a.createdAt) < moment(b.createdAt)) {
                    return -1;
                }
                if (moment(a.createdAt) > moment(b.createdAt)) {
                    return 1;
                }
                return 0;
            },
            render: (value) => moment(value).locale("es").format("L"),
            width: "10%",
            ellipsis: true,
            align: "center",
        },
        // {
        //     title: "Fecha De Entrega",
        //     dataIndex: "fechaEntrega",
        //     key: "fechaEntrega",
        //     sorter: (a, b) => {
        //         if (moment(a.fechaEntrega) < moment(b.fechaEntrega)) {
        //             return -1;
        //         }
        //         if (moment(a.fechaEntrega) > moment(b.fechaEntrega)) {
        //             return 1;
        //         }
        //         return 0;
        //     },
        //     render: (value) => moment(value).locale("es").format("L"),
        //     width: "10%",
        //     ellipsis: true,
        //     align: "center",
        // },
        {
            title: "Moneda",
            dataIndex: "moneda",
            key: "moneda",
            align: "center",
            width: "8%",
            ellipsis: true,
        },
        {
            title: "Subtotal",
            dataIndex: "subtotal",
            key: "subtotal",
            sorter: (a, b) => {
                if (a.subtotal < b.subtotal) {
                    return -1;
                }
                if (a.subtotal > b.subtotal) {
                    return 1;
                }
                return 0;
            },
            render: (value) => dineroDisabledMask(value),
            buscar: "subtotal",
            width: "8%",
            ellipsis: true,
            align: "right",
        },
        {
            title: "Total",
            dataIndex: "total",
            key: "total",
            sorter: (a, b) => {
                if (a.total < b.total) {
                    return -1;
                }
                if (a.total > b.total) {
                    return 1;
                }
                return 0;
            },
            render: (value) => dineroDisabledMask(value),
            buscar: "total",
            width: "8%",
            ellipsis: true,
            align: "right",
        },
        // {
        //     title: "Estado",
        //     dataIndex: "estado",
        //     key: "estado",
        //     render: (value) => {
        //         let buttons = [];

        //         if (value === 0) {
        //             buttons.push(<Tag color="red">Cancelada</Tag>);
        //         }
        //         if (value === 1) {
        //             buttons.push(<Tag color="blue">Sin recibir</Tag>)
        //         }
        //         if (value === 2) {
        //             buttons.push(<Tag color="orange">Recibido parcialmente</Tag>)
        //         }
        //         if (value === 3) {
        //             buttons.push(<Tag color="green">Recibido</Tag>)
        //         }

        //         return <Space>{buttons}</Space>;

        //     },
        //     width: "10%",
        //     ellipsis: true,
        // },
        {
            title: "Acción",
            dataIndex: "accion",
            key: "accion",
            render: (value, record, index) => {
                let buttons = [];
                if (value.estado === 1 && value.estadoFactura === 0) {
                    buttons.push(
                        <>

                            <Popconfirm
                                title={`Confirma la eleccion de esta orden de compra #${record.numero}?`}
                                onConfirm={() => this.confirmarOrdenDeCompra(record._id)}
                                okText="Sí"
                                cancelText="No"
                            >
                                <ButtonItem
                                    type="primary"
                                    icon={<AppstoreOutlined />}
                                    verde
                                    lessTime
                                >
                                    Elegir
                                </ButtonItem>
                            </Popconfirm>
                        </>
                    );
                }

                return <Space>{buttons}</Space>;
            },
            width: "10%",
            ellipsis: true,
        },
    ];

    render() {
        const { visible } = this.props;
        const { loading, ordenes, currentPage, pageSize, totalOrdenes } = this.state;

        return (
            <ModalItem
                title={
                    <Space>
                        <AppstoreOutlined style={{ color: '#00b5e2' }} />
                        <span>Ordenes pendientes</span>
                    </Space>
                }
                visible={visible}
                onCancel={this.handleCancel}
                footer={null}
                width={1200}
                style={{ top: 20 }}
                destroyOnClose={true}
                spinning={loading}
                zIndex={1000}
            >
                {/* Filtros */}
                <Row gutter={16} style={{ marginBottom: '16px' }}>
                    <Col span={24}>
                        <InputItem
                            prefix={<SearchOutlined />}
                            placeholder="Buscar orden..."
                            value={this.state.searchTerm}
                            onChange={this.onSearchChange}
                            size="large"
                            allowClear
                            autoFocus
                        />
                    </Col>
                </Row>

                {/* Información de resultados */}
                <div style={{ marginBottom: '16px' }}>
                    <Text style={{ fontSize: '14px', color: '#666' }}>
                        Mostrando {ordenes.length} de {totalOrdenes} ordenes
                    </Text>
                </div>

                {/* Tabla de ordenes */}
                <Table
                    dataSource={ordenes}
                    columns={this.getColumnsOrdenesDeCompra()}
                    spinning={loading}
                    pagination={{
                        current: currentPage,
                        pageSize: pageSize,
                        total: totalOrdenes,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        showTotal: (total, range) =>
                            `${range[0]}-${range[1]} de ${total} ordenes`,
                        pageSizeOptions: ['10', '20', '50'],
                        showLessItems: true,
                        hideOnSinglePage: false,
                        simple: false
                    }}
                    onChange={this.onTableChange}
                    scroll={{ y: 400 }}
                    locale={{
                        emptyText: loading ? 'Cargando ordenes...' : 'No se encontraron ordenes'
                    }}
                />
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(ModalAgregarInsumosAExistente);